const crypto_eval = require("crypto-js");

export const LOGIN_SUCCESS = "LOGINSUCCESS";
export const FROM_PAGE = "FROM_PAGE";
export const SET_CONTEXT_DETAIL = "SET_CONTEXT_DETAIL";
export const SET_PAGE_TOBE_DISPLAYED = "SET_PAGE_TOBE_DISPLAYED";
export const SET_ERROR_DETAILS = "SET_ERROR_DETAILS";
export const LOGIN = "LOGIN";
export const FORGET_USERNAME = "FORGET_USERNAME";
export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const SUCCESS = "SUCCESS";
export const ERROR = "ERROR";
export const OTP = "OTP";
export const LOGINOTP = "LOGINOTP";
export const SET_GSM_ACCESS = "SET_GSM_ACCESS";
export const CAPTCHA_VALIDATE = "CAPTCHA_VALIDATE";
export const FORGET_PASSWORD_CHANGE = "FORGET_PASSWORD_CHANGE";
export const CELL_NUM_REGEX = /^\+?\d{10,20}$/
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@+#"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z])/
export const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9!@#$&()\\-`.+,/\"]{8,})$/
export const LOWER_CASE_REGEX = /(?=.*[a-z])/
export const UPPER_CASE_REGEX = /(?=.*[A-Z])/
export const EIGHT_CHAR_REGEX = /.{8,}/
export const NUMBER_REGEX = /(?=.*\d)/
export const OTP_MSISDN = "OTP_MSISDN";
export const SET_WRONG_OTP = "SET_WRONG_OTP";
export const EMAIL = "EMAIL";
export const SET_SUCCESS_DETAILS = "SET_SUCCESS_DETAILS";
export const USERNAME_SUCCESS_MSG = "Your username has been sent to ";
export const PASSWORD_SUCCESS_MSG = "You've successfully reset your password ";
export const AUTH_TOKEN = "vod-vb-web-auth-token";
export const MAXIMUM_CODE_LENGTH = 6;

//Register screen
export const REGISTER = "REGISTER";
export const REGISTERPART1 = "REGISTERPART1";
export const REGISTERPART2 = "REGISTERPART2";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_ERROR = "REGISTER_ERROR";
export const ON_BOARDING_FIXED = "ON_BOARDING_FIXED";
export const ON_BOARDING_GSM = "ON_BOARDING_GSM";
export const ON_BOARDING = "ON_BOARDING";
export const TERMS_AND_CONDITIONS = "TERMS_AND_CONDITIONS";


export const redirectToFixProducts = () => {
    window.location.href = `${process.env.REACT_APP_FIX_PRODUCTS_URL}`;
};

export const redirectToDashboard = () => {
    window.location.href = `${process.env.REACT_APP_DASHBOARD_URL}`;
};

export const loadScript = (src, compId) => {
    const script = document.createElement('script');
    script.src = src; // URL for the third-party library being loaded.
    script.id = compId;
    document.body.appendChild(script);
};

export const getAuthToken = (cName) => {
    const name = cName + "=";
    const cDecoded = decodeURIComponent(document.cookie);
    const cArr = cDecoded.split('; ');
    let res;
    cArr.forEach(val => {
        if (val.indexOf(name) === 0) res = val.substring(name.length);
    })
    return res
}

function encryptFun(data, encrypt) {
    const keys = process.env.REACT_APP_ENCRYPT_KEY;
    const key  = crypto_eval.enc.Latin1.parse(keys);
    const iv   = crypto_eval.enc.Latin1.parse(keys);
    const ivProp = {iv:iv,mode:crypto_eval.mode.CBC,padding:crypto_eval.pad.ZeroPadding};
    let result = '';
    if(encrypt) {
        result = crypto_eval.AES.encrypt(data, key, ivProp);
    } else {
        result = crypto_eval.AES.decrypt(data,key, ivProp);
        result = result.toString(crypto_eval.enc.Utf8);
    }

    return result;
}

export const encryptStr = value => {
    return encryptFun(value, true);
}

export const decryptStr = value => {
    return encryptFun(value, false);
}

export const removeCookie = (name) => {
    const domain = window.location.hostname.split(".");
    const d = `.${domain.filter(d => d.indexOf('www') === -1 ).join(".")}`;
    document.cookie=`${name}=;max-age=0;path=/;domain=${d}`;
}

export const resetStore = () => {
    localStorage.setItem('state','');
    localStorage.setItem('_masterAccount','');
    localStorage.setItem('isTransnetUser','');
    localStorage.setItem('MenuData','');
    sessionStorage.setItem('state','');
    sessionStorage.setItem('_masterAccount','');
    sessionStorage.setItem('isTransnetUser','');
    sessionStorage.setItem('MenuData','');
}
